<template>
    <div>
        <strong>{{title}}</strong>
        <div class="select-board select-button-box">
            <button v-for="(item, index) in selectData" :key="index">{{item.price}}</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SelectBoard',
    props: ['selectData', 'title'],
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/common/selectBoard.scss';
</style>